import { memo } from 'react'
import Markdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import { cn } from '@/lib/utils'

import '@/components/organisms/markdown-editor/markdown-editor.css'
import './chat-markdown.css'

import { chatMarkdownComponents } from './chat-markdown-components.helper'
import { repairMarkdownTables } from './chat-markdown-table-repair.helper'
import { sanitizeAgentMessage } from './chat-message-sanitize.helper'

export type ChatMarkdownVariant = 'user' | 'assistant' | 'system' | 'note' | 'error'

export interface ChatMarkdownContentProps {
  content: string

  variant?: ChatMarkdownVariant

  className?: string
}

const variantClassMap: Record<ChatMarkdownVariant, string> = {
  user: 'chat-markdown-user',
  assistant: 'chat-markdown-assistant',
  system: 'chat-markdown-assistant',
  note: 'chat-markdown-note',
  error: 'chat-markdown-assistant',
}

const remarkPluginList = [remarkGfm, remarkBreaks]

const ChatMarkdownContentBase: React.FC<ChatMarkdownContentProps> = ({
  content,
  variant = 'assistant',
  className,
}) => {
  if (!content) {
    return null
  }

  return (
    <div className={cn('saaga-wysiwyg', variantClassMap[variant], className)}>
      <Markdown remarkPlugins={remarkPluginList} components={chatMarkdownComponents}>
        {repairMarkdownTables(variant === 'user' ? content : sanitizeAgentMessage(content))}
      </Markdown>
    </div>
  )
}

export const ChatMarkdownContent = memo(ChatMarkdownContentBase)

ChatMarkdownContent.displayName = 'ChatMarkdownContent'
